export const START_LOADING            = 'START_LOADING'

export const END_LOADING              = 'END_LOADING'

export const FETCH_ALL_POSTS          = 'FETCH_ALL_POSTS'

export const CONTACT_US_MESSAGES      = 'CONTACT_US_MESSAGES'

export const MODE                     = 'MODE'